const MessageTablesEmpty = ({messageNoResults="No results", messageInit="Click 'Filter' or hit Enter to show the list", counterSearched=0}) => {

  return (
    <div className="messageTableEmpty">
      {counterSearched > 0 ? <>{messageNoResults}</> : <>{messageInit}</>}
    </div>
  )
}

export default MessageTablesEmpty;